import "core-js/modules/web.timers";

/*
  Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

  This software is the confidential and proprietary information of Wells Fargo
  bank. ('Confidential Information'). You shall not disclose such Confidential
  Information and shall use it only in accordance with the terms of the license
  agreement you entered into with WellsFargo.

  Author: Thomas Barry

  Description:
 */
// The browser component in some versions of Android don't scroll a field receiving
// focus into view. This workaround fixes that. Taken from:
// http://stackoverflow.com/questions/23757345/android-does-not-correctly-scroll-on-input-focus-if-not-body-element
export default (function () {
  if (/Android [4-6]/.test(window.navigator.appVersion)) {
    window.addEventListener('resize', function () {
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        window.setTimeout(function () {
          document.activeElement.scrollIntoView();
        }, 0);
      }
    });
  }
});